/**
 * The type of (redux) action which sets the visibility of the audio settings popup.
 */
export const SET_AUDIO_SETTINGS_VISIBILITY = 'SET_AUDIO_SETTINGS_VISIBILITY';
/**
 * The type of (redux) action which sets the visibility of the video settings popup.
 */
export const SET_VIDEO_SETTINGS_VISIBILITY = 'SET_VIDEO_SETTINGS_VISIBILITY';
export const SET_REACTION_SETTINGS_VISIBILITY = 'SET_REACTION_SETTINGS_VISIBILITY';
